// auto-generated by prebuild
export const APP_VERSION = "5.62.3";
